//Sidebar.tsx
import { Menu } from 'antd';
import {
  PieChartOutlined,
  AppstoreOutlined,
  InboxOutlined,
  SettingOutlined,
  DollarOutlined,
  ShoppingCartOutlined,
} from '@ant-design/icons';
import logo from '../assets/logo.png';
import { useNavigate, useLocation } from 'react-router-dom';

type SidebarProps = { onNavigate?: () => void };

const Sidebar = ({ onNavigate }: SidebarProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      key: '/',
      icon: <PieChartOutlined style={{ fontSize: '20px' }} />,
      label: 'Панель управления'
    },
    {
      key: '/products',
      icon: <AppstoreOutlined style={{ fontSize: '20px' }} />,
      label: 'Товары'
    },
    {
      key: '/products/coils',
      label: 'Катушки зажигания'
    },
    {
      key: '/products/plugs',
      label: 'Свечи зажигания'
    },
    {
      key: '/products/wires',
      label: 'Наконечники и проводки'
    },
    {
      key: '/products/sensors',
      label: 'Датчики'
    },
    {
      key: '/products/clocks',
      label: 'Рулевые шлейфы'
    },
    {
      key: '/receive',
      icon: <InboxOutlined style={{ fontSize: '20px' }} />,
      label: 'Принять товар'
    },
    {
      key: '/sales',
      icon: <ShoppingCartOutlined style={{ fontSize: '20px' }} />,
      label: 'Продажа'
    },
    {
      key: '/expenses',
      icon: <DollarOutlined style={{ fontSize: '20px' }} />,
      label: 'Расходы'
    },
    {
      key: '/settings',
      icon: <SettingOutlined style={{ fontSize: '20px' }} />,
      label: 'Настройки'
    }
  ];

  return (
    <div
      style={{
        width: 300,
        flexShrink: 0,
        height: '100vh',
        backgroundColor: '#1f1f1f',
        borderRight: '3px solid #b70000'
      }}
    >
      <div style={{ padding: '16px 12px 8px 12px', textAlign: 'center' }}>
        <img
          src={logo}
          alt="Logo"
          style={{
            width: '100%',
            maxWidth: '230px',
            height: 'auto',
            display: 'block',
            margin: '0 auto'
          }}
        />
      </div>

      <Menu
        mode="inline"
        selectedKeys={[location.pathname]}
        onClick={({ key }) => { navigate(key); onNavigate?.(); }}
        style={{
          backgroundColor: '#1f1f1f',
          borderTop: '2px solid #b70000',
          paddingTop: '10px'
        }}
        items={menuItems}
        theme="dark"
      />
    </div>
  );
};

export default Sidebar;
